export default "__VITE_ASSET__BcERNnes__"